// Every <img> tag that can load the same S3/CDN product-photo URL as
// designDownload.ts's loadImage() (Save/Preview/Download/3D canvas
// compositing, which always sets crossOrigin='anonymous') must resolve
// crossOrigin the same way for that URL, or risk a real, confirmed
// production bug: the browser's HTTP cache can serve an earlier no-cors
// response to a later cors-mode request for the identical URL, and that
// request fails outright ("No Access-Control-Allow-Origin header is
// present") even though the origin's own CORS policy is correct — not a
// repeat-visit-only issue, reproduced even within a single fresh page load
// when two different <img> elements for the same URL disagree on request
// mode (e.g. DesignerWorkspace's main canvas image vs. SideSelector's
// thumbnail strip). See project_preview_tab_cors_cache_race_fix_2026-08-13
// and project_designer_canvas_cors_cache_race_2026-08-14 in memory for the
// full incident history — this collided twice already before being
// centralized here.
//
// Only returns 'anonymous' when the URL is genuinely cross-origin — local
// dev can point these paths at the same origin (e.g. a same-origin
// /storage/ proxy), where forcing crossOrigin would incorrectly require
// that origin to also send CORS headers on a same-origin request.
export function crossOriginForUrl(url: string | undefined): 'anonymous' | undefined {
  if (!url) return undefined;
  try {
    return new URL(url, window.location.href).origin !== window.location.origin
      ? 'anonymous'
      : undefined;
  } catch {
    return undefined;
  }
}
